module.exports = __webpack_public_path__ + "zvetseni-prsou_40_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_40_before.jpg
// module id = 1334
// module chunks = 0